import React, { forwardRef, useContext } from 'react';
import classNames from 'classnames';
import {
  makeStyles, Button, mergeClasses, shorthands, tokens,
} from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { NavItemCommonProps } from '@bingads-webui-fluent-component/global-menu-container';

import { LogoImage } from './logo-image';
import type { II18n } from './types';

const useStyles = makeStyles({
  button: {
    marginRight: tokens.spacingHorizontalS,
    marginLeft: tokens.spacingHorizontalS,
    height: '48px',
    width: '165px',
    ...shorthands.flex(0, 0, 'auto'),
    ...shorthands.padding(tokens.spacingHorizontalS),
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '165px',
  },
  logo: {
    width: '182px',
    ...shorthands.flex(0, 0, 'auto'),
  },
});

export const Branding = forwardRef<HTMLButtonElement, NavItemCommonProps & { onLogoClick:()=>void }>(({ onLogoClick }, ref) => {
  const classes = useStyles();
  const i18n: II18n = useContext(I18nContext);

  return (
    <Button
      className={mergeClasses(classes.button, 'branding-button')}
      ref={ref}
      appearance="subtle"
      onClick={onLogoClick}
      aria-label={i18n.getString(_TL_('Microsoft Advertising'))}
    >
      <div className={classNames(classes.container, 'branding')}>
        <LogoImage
          className={classNames(classes.logo, 'global-menu-logo')}
        />
      </div>
    </Button>
  );
});
